import React from 'react'
import { useNavigate } from 'react-router'
import { InfoHeader } from '@mobi/component-library/Typography/InfoHeader'
import { Button } from '@mobi/component-library/Base/Buttons/Button'
import { spacing } from '@mobi/component-library/Foundations'
import { MainContainer } from '@core/Components/Containers'

const enum LocalConstants {
  Title = 'This Profile Is Currently Unavailable',
}

export const RestrictedProfile: React.FC = () => {
  const navigate = useNavigate()

  const handleBackClick = () => {
    navigate(-1)
  }

  return (
    <MainContainer
      testId='BetLoop.RestrictedProfile'
      style={{ justifyContent: 'center', padding: spacing.md, gap: spacing.md }}
      background='white'
    >
      <InfoHeader size='large' icon='warning' header={LocalConstants.Title} />
      <Button onClick={handleBackClick} size='md' color='primary'>
        Back
      </Button>
    </MainContainer>
  )
}
